import { AuthState } from '@okta/okta-auth-js';

import { CommissionRateMassCreates } from '../../services/backend/CommissionRateMassCreates';
import { useBaseApiClient } from '../useBaseApiClient';

export const useCommissionRateMassCreates: () => CommissionRateMassCreates<AuthState> = () => {
  return useBaseApiClient(CommissionRateMassCreates);
};
